export const timeNowInMinutes = () => Math.floor(Date.now() / 60000); // 2000 for seconds [For Testing] | 60000 for Minutes
